<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
      <div class="col-12 mb-3 mb-xl-0">

        <!-- Banner de nueva versión -->
        <div v-if="showNewVersionBanner" class="card shadow new-version-card">
          <div class="new-version-body">
            <div class="new-version-icon">
              <i class="fas fa-rocket"></i>
            </div>
            <h2 class="new-version-title">¡Hay una nueva versión disponible!</h2>
            <p class="new-version-text">
              El módulo de <strong>Facturación</strong> ha sido actualizado y ahora vive en la
              nueva consola de Canplast. Haz clic en el botón para acceder a la versión más reciente.
            </p>
            <a
              href="https://consola-v2.canplast.net/docs-venta/facturacion"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-new-version"
            >
              <i class="fas fa-external-link-alt mr-2"></i>
              Ir a la nueva consola
            </a>
            <button
              type="button"
              class="btn-it-authorization"
              @click="bypassWithITAuthorization"
            >
              <i class="fas fa-shield-alt mr-2"></i>
              Tengo autorización de TI para usar esta versión por esta ocasión
            </button>
          </div>
        </div>

        <!-- Vista normal -->
        <div v-else class="card shadow">
          <tabs
            tabContentClasses="mb-5"
            tabNavClasses="px-4 py-2"
            @tabChanged="openTab"
          >
            <tab title="Entregas abiertas">
              <table-open-deliveries v-if="openedTabs.includes(0)" />
            </tab>
            <tab title="Facturas anticipo">
              <AdvanceInvoices v-if="openedTabs.includes(1)" />
            </tab>
            <tab title="Facturas sin entregar">
              <table-undelivered-invoices v-if="openedTabs.includes(2)" />
            </tab>
            <tab title="Facturas entregadas">
              <table-delivered-invoices v-if="openedTabs.includes(3)" />
            </tab>
            <tab title="Facturas sin timbrar">
              <table-unstamped-invoices v-if="openedTabs.includes(4)" />
            </tab>
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tab from "@/components/Tabs/Tab.vue";
import TableOpenDeliveries from "./tables/TableOpenDeliveries.vue";
import TableUndeliveredInvoices from "./tables/TableUndeliveredInvoices.vue";
import TableDeliveredInvoices from "./tables/TableDeliveredInvoices.vue";
import TableUnstampedInvoices from "./tables/TableUnstampedInvoices.vue";
import AdvanceInvoices from "./tables/AdvanceInvoices.vue";
import { isLegacyRetired } from "@/legacyAccess";
export default {
  components: {
    Tab,
    TableOpenDeliveries,
    TableUndeliveredInvoices,
    TableDeliveredInvoices,
    TableUnstampedInvoices,
    AdvanceInvoices,
  },
  data() {
    return {
      openedTabs: [],
      showNewVersionBanner: !isLegacyRetired(),
    };
  },
  methods: {
    openTab(params) {
      if (!this.openedTabs.find((tab) => tab === params)) {
        this.openedTabs.push(params);
      }
    },
    bypassWithITAuthorization() {
      this.$swal
        .fire({
          title: "¿Tienes autorización de TI?",
          text: "Solo continúa si TI te autorizó expresamente a usar esta versión por esta ocasión.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, tengo autorización",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.showNewVersionBanner = false;
          }
        });
    },
  },
};
</script>
<style>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background: linear-gradient(87deg, #f5365cd7 0, #f55f36d3 200%) !important;
}
.nav-pills .nav-link {
  font-weight: 600 !important;
}

/* Banner nueva versión */
.new-version-card {
  border: none;
  overflow: hidden;
}
.new-version-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
}
.new-version-icon {
  font-size: 3.5rem;
  color: #f5365c;
  margin-bottom: 20px;
  animation: bounce 1.4s infinite;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}
.new-version-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #32325d;
  margin-bottom: 14px;
}
.new-version-text {
  font-size: 1.05rem;
  color: #525f7f;
  max-width: 520px;
  line-height: 1.7;
  margin-bottom: 32px;
}
.btn-new-version {
  display: inline-flex;
  align-items: center;
  padding: 14px 36px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 50px;
  color: #fff !important;
  background: linear-gradient(87deg, #f5365c 0, #f55f36 200%);
  border: none;
  box-shadow: 0 6px 20px rgba(245, 54, 92, 0.35);
  text-decoration: none;
  transition: transform 0.15s, box-shadow 0.15s;
}
.btn-new-version:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(245, 54, 92, 0.45);
}
.btn-it-authorization {
  margin-top: 18px;
  background: transparent;
  border: none;
  color: #8898aa;
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  padding: 6px 12px;
  transition: color 0.15s;
}
.btn-it-authorization:hover {
  color: #525f7f;
}
.btn-it-authorization:focus {
  outline: none;
}
</style>
